import { Button, Checkbox, Drawer, Form, Input, message, Select, Space } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import React, { useContext, useEffect } from 'react';
import { useSceneServiceGetBackendv2Scene1, useTemplatePresetsServicePutBackendv2Templatepreset, useTemplatesServiceGetBackendv2Template, useTemplatesServiceGetBackendv2Template1 } from '../../backendapi/queries';
import { TemplatePresetEditDTO, TemplatePresetViewDTO } from '../../backendapi/requests';
import { ConfigContext } from '../../contexts/ConfigContext';
import ImageFileUpload from '../Inputs/ImageFileUpload';
import { BASE_PATH } from '../../Environment';


const EditTemplatePreset: React.FC<{ preset?: TemplatePresetViewDTO, isOpen: boolean, onClose: () => void }> = ({ preset, isOpen, onClose }) => {

    const { currentClient } = useContext(ConfigContext);
    const { data: templates } = useTemplatesServiceGetBackendv2Template({ clientId: currentClient.id }, undefined, { enabled: isOpen });
    const { data: template } = useTemplatesServiceGetBackendv2Template1({ key: preset?.templateId ?? 0 }, undefined, { enabled: preset != undefined });
    const { data: scene } = useSceneServiceGetBackendv2Scene1({ key: template?.sceneId ?? 0 }, undefined, { enabled: template != undefined });
    const [form] = Form.useForm<TemplatePresetEditDTO>();
    const [messageApi, contextHolder] = message.useMessage();
    const { mutateAsync: updateTemplate, isPending } = useTemplatePresetsServicePutBackendv2Templatepreset();



    const onSubmit = () => {
        form.submit();
    }

    const onFinish = () => {
        if (preset) {
            const templateData = form.getFieldsValue(true) as TemplatePresetEditDTO;
            updateTemplate({ key: preset.id, requestBody: templateData })
                .then(() => {
                    messageApi.success("preset updated");
                    onClose();
                }).catch(reason => {
                    messageApi.error(JSON.stringify(reason));
                });
        }
    };

    useEffect(() => {
        if (preset) {
            form.setFieldsValue({ ...preset, autoRenderDisabledCameras: false, autoRenderEnabledCameras: false });
        }
    }, [preset, form])

    return (
        <>
            {contextHolder}

            <Drawer
                title={`Edit ${preset?.title}`}
                size={720}
                onClose={onClose}
                open={isOpen}
                extra={
                    <Space>
                        <Button onClick={onClose}>Cancel</Button>
                        <Button onClick={onSubmit} type="primary" loading={isPending}>
                            Submit
                        </Button>
                    </Space>
                }
            >
                <Form
                    name="basic"
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}>

                    <Form.Item rules={[{ required: true }]} name='title' label="Title">
                        <Input />
                    </Form.Item>

                    <Form.Item name="isEnabled" valuePropName="checked">
                        <Checkbox>Enabled</Checkbox>
                    </Form.Item>

                    <Form.Item name='templateId' label="Template">
                        <Select allowClear options={templates?.value.map(e => ({ label: e.title, value: e.id }))} />
                    </Form.Item>

                    <Form.Item name='configurationSpec' label="Configuration">
                        <TextArea rows={6} />
                    </Form.Item>

                    <Form.Item label='Cameras'>
                        {(scene?.cameras ?? []).map((camera) => (
                            <Space style={{ display: 'flex', marginBottom: 6 }} align="baseline" key={`${camera.id}`}>
                                <ImageFileUpload size={100} action={`${BASE_PATH}/backendv2/templatepreset/${preset?.id}/camera/${camera.id}/image`} title='thumbnail' previewPath={`${BASE_PATH}/backendv2/templatepreset/${preset?.id}/camera/${camera.id}/image`} />
                                <h5>{camera.cameraName}</h5>
                            </Space>
                        ))}
                    </Form.Item>
                </Form>
            </Drawer>
        </>

    );
};

export default EditTemplatePreset;